import { http } from "~/utils";
export default {
    list: async (page, filters) => {
        return http
            .get(`/india/non-sode/cpo-non-sode/`, {
                params: {
                    page,
                    ...filters
                }
            })
            .then(response => response && response.data);
    },
    create: async body => {
        return http.post("/india/non-sode/non-sode/", body).then(response => response && response.data);
    },
    getById: async id => {
        return http.get(`/india/non-sode/cpo-non-sode/${id}/`).then(response => response && response.data);
    },
    update_approve_or_reject: async (id, body) => {
        return await http
            .put(`/india/non-sode/non-sode/${id}/approve-or-reject/`, body)
            .then(response => response && response.data);
    }
    // update: async (id, body) => {
    //     return await http
    //         .put(`/nos/master-data-item/${id}/`, body)
    //         .then(response => response && response.data);
    // },
    // partialUpdate: async (id, body) => {
    //     return await http
    //         .patch(`/nos/master-data-item/${id}/`, utils.clearObjectNulls(body))
    //         .then(response => response && response.data);
    // },
    // deleteById: async id => {
    //     return await http
    //         .delete(`/nos/master-data-item/${id}/`)
    //         .then(response => response && response.data);
    // }
};
